module.exports = __webpack_public_path__ + "static/media/what_rent.97ff1083.svg";